import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VariantController } from './item-variant.controller';
import { VariantService } from './item-variant.service';
import {VariantAdapter} from './dto/item-variant.adapter';
import { Variant } from './item-variant.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';

@Module({
  imports: [
    TypeOrmModule.forFeature([Variant]),],
  controllers: [VariantController],
  providers: [VariantService,VariantAdapter,ApplicationExceptionHandler],
  exports: [VariantService]
})
export class ItemVariantModule {}
